import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ServiceMenu from './page/ServiceMenu';

export default function ServiceMenuFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/`}>
          <ServiceMenu />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
